<template lang="pug">
span#reports
</template>
<script>
import { mapFields } from 'vuex-map-fields'
import moment from 'moment'
export default {
  data () {
    return {
      filter: {
        order: 'desc',
        page: 0,
        perPage: 5
      }
    }
  },
  created () {
    this.dateInterval = {
      timestamp1: moment().subtract(1, 'week').startOf('day').format('YYYY-MM-DD[T]HH:mm:ss'),
      timestamp2: moment().endOf('day').format('YYYY-MM-DD[T]HH:mm:ss')
    }
  },
  watch: {
    dateInterval: {
      deep: true,
      handler (nV) {
        this.updatedDate()
      }
    }
  },
  components: {
  },
  computed: {
    ...mapFields('reports', ['dateInterval'])
  },
  methods: {
    updatedDate () {
      this.filter.from = this.dateInterval.timestamp1
      this.filter.to = this.dateInterval.timestamp2
    }
  }
}
</script>
<style lang="scss">
</style>
